import { useTranslation } from 'react-i18next';

export type TChangeTone = 'neutral' | 'up' | 'down';

const getPercentChange = (current?: number, previous?: number): number | undefined =>
    current === undefined || previous === undefined || previous === 0
        ? undefined
        : ((current - previous) / previous) * 100;

// Week-over-week change of a figure, as a KPI hint and the tone it is shown in.
export const useStatsChange = () => {
    const { t } = useTranslation();

    const changeHint = (current?: number, previous?: number): string | undefined => {
        const change = getPercentChange(current, previous);
        if (change === undefined) {
            return undefined;
        }
        if (Math.round(change) === 0) {
            return t('reports.kpi.unchanged');
        }
        return `${change > 0 ? '▲' : '▼'} ${Math.round(Math.abs(change))}% ${t('reports.kpi.vsPrevious')}`;
    };

    const changeTone = (current?: number, previous?: number): TChangeTone => {
        const change = getPercentChange(current, previous);
        if (change === undefined || Math.round(change) === 0) {
            return 'neutral';
        }
        return change > 0 ? 'up' : 'down';
    };

    return { changeHint, changeTone };
};
